// sessionStorage keys used to keep session/uid across the SSO redirect.
export const LOCAL_SESSION_KEY = 'oauth_local_session';
export const LOCAL_UID_KEY = 'oauth_local_uid';
